module.exports = __webpack_public_path__ + "static/img/company5.c63b633.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/company5.png
// module id = cCjU
// module chunks = 1